const STUDIO_URL = process.env.REACT_APP_STUDIO_URL || "/editor";
const _studioBase = String(STUDIO_URL).replace(/\/+$/, "");
const PLC_EDITOR_URL = `${_studioBase}${/\/editor$/i.test(_studioBase) ? "" : "/editor"}/plc`;
const MACHINE_HEALTH_URL = `${_studioBase}?surface=machine-health`;

const SYSTEM_CATEGORY_ITEMS = [
  "Routing",
  "Sidebar",
  "Access Control",
];

export { STUDIO_URL, PLC_EDITOR_URL, MACHINE_HEALTH_URL, SYSTEM_CATEGORY_ITEMS };
